import Image from 'next/image';
import styled from 'styled-components';
import requiredImage from '../assets/error.png';

const ErrorMessage = styled.div`
  background-color: #faf0ef;
  color: #af3636;
`;

const ImageContainer = styled.span`
  width: 40px;
`;

export const ErrorInfo = ({ message = '' }) => {
  return (
    <ErrorMessage className="is-flex has-rds-pv-16 has-rds-ph-24 has-rds-mb-16">
      <ImageContainer className="error-info-image has-rds-mr-8">
        <Image
          src={requiredImage}
          key="error"
          alt=""
          height={16}
          width={16}
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </ImageContainer>
      <span>
        <div className="is-rds-body-3">
          <b>{message}</b>
        </div>
      </span>
    </ErrorMessage>
  );
};
